import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  label: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 600,
    marginBottom: 10,
    fontSize: '0.75rem',
  },
  buttonRoot: {
    borderRadius: 1000,
    borderWidth: 2,
    borderColor: COLORS.GREY_DARK,
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    margin: '0 5px',
    lineHeight: 1,
    paddingTop: 8,
    paddingBottom: 8,
    textTransform: 'none',
    marginBottom: 5,
  },
  normalButtonRoot: {
    color: '#008539',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  selectedButtonRoot: {
    backgroundColor: COLORS.GREY_DARK,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: COLORS.GREY_DARK,
    },
  },
  buttonIcon: {
    marginRight: 5,
    height: 16,
  },
});

export default styles;
